import { getMsgClient } from '@/shared/utils/stringsUtils'
import { notification } from 'antd'
import SvgIcon from '../SvgIcon'
import './styles.scss'

function notice({
  msg = '',
  desc,
  place,
  isSuccess = true,
}: {
  msg: string
  desc?: string
  place?: 'bottomRight' | 'top' | 'topLeft' | 'topRight' | 'bottom' | 'bottomLeft' | undefined
  isSuccess?: boolean
}) {
  const style = {
    background: isSuccess ? '#E5F5EB' : '#FCCED4',
  }

  notification.open({
    className: `notification-custom ${isSuccess ? 'success' : 'error'}`,
    style,
    placement: place || 'bottomRight',
    message: (
      // <div
      //   dangerouslySetInnerHTML={{
      //     __html: getMsgClient(msg || ''),
      //   }}
      // />
      <div>{getMsgClient(msg || '')}</div>
    ),
    description: (
      // <div
      //   dangerouslySetInnerHTML={{
      //     __html: getMsgClient(desc || ''),
      //   }}
      // />
      <div>{getMsgClient(desc || '')}</div>
    ),
    icon: isSuccess ? <SvgIcon name="notice-success" /> : <SvgIcon name="notice-error" />,
    duration: 3,
  })
}

export default notice
